export default {
  home: "Главная",
  user: "Пользователь",
  users: "Пользователи",
  role: "Роль",
  roles: "Роли",
  permission: "Право доступа",
  permissions: "Права доступа",
  workplace: "Рабочее место",
  workplaces: "Рабочие места",
  office: "Компания",
  offices: "Компании",
  profile: "Профиль",
  exit: "Выход",
  add: "Добавить",
  edit: "Редактировать",
  delete: "Удалить",
  save: "Сохранить",
  cancel: "Отмена",
  yes: "Да",
  no: "Нет",
  error: "Ошибка",
  success: "Успех",
  warning: "Предупреждение",
  info: "Информация",
  basicInfo: "Основная информация",
  search: "Поиск",
  inn: "ИНН",
  kpp: "КПП",
  okpo: "ОКПО",
  ceo: "Генеральный директор",
  basedOn: "Действует на основании",
  proxy: "Доверенность №",
  details: "Реквизиты",
  bank: "Наименование банка",
  banks: "Банки",
  createBank: "Создать банк",
  editBank: "Редактировать банк",
  corrAccount: "Корреспондентский счет",
  foreignBankAccounts: "Счета в иностранном банке",
  currentAccount: "IBAN/Account number",
  bik: "БИК банка",
  token: "Токен ЭЦП",
  name: "Название",
  description: "Описание",
  action: "Действие",
  numberOfRecords: "Количество записей",
  information: "Информация",
  key: "Ключ",
  module: "Модуль",
  close: "Закрыть",
  rowsPerPage: "Строк на странице",
  changePassword: "Сменить пароль",
  firstName: "Имя",
  lastName: "Фамилия",
  email: "Электронная почта",
  password: "Пароль",
  login: "Логин",
  authorization: "Авторизация",
  signIn: "Войти",
  removalDesc: "Вы действительно хотите удалить этот элемент?",
  removal: "Удаление",
  post: "Должность",
  userLogin: "Логин пользователя",
  surname: "Фамилия",
  firstname: "Имя",
  invalid_password: "Неверный пароль",
  phone: "Телефон",
  middleName: "Отчество",
  noRecords: "Нет записей",
  userName: "Логин",
  selectAtLeastOneRole: "Выберите хотя бы одну роль",
  selectAtLeastOnePermission: "Выберите хотя бы один пермишен",
  formValidationError: "Ошибка валидации формы",
  invalid_permission: "Недостаточно прав",
  invalid_phone_number_format: "Невалидный номер телефона",
  invalid_email: "Невалидный email",
  modules: "Модули",
  pageNotFound: "Страница не найдена",
  toHomePage: "На главную",
  session_expired: "Сессия истекла",
  sessionExpired: "Сессия истекла",
  gender: "Пол",
  genders: "Пол",
  internal_server_error: "Внутреняя ошибка сервера",
  deviceType: "Тип устройства",
  deviceTypes: "Типы устройств",
  "device types": "Типы устройств",
  zoneGroup: "Группа зоны",
  zoneGroups: "Группы зон",
  "zone groups": "Группы зон",
  userType: "Тип пользователя",
  userTypes: "Типы пользователей",
  "user types": "Типы пользователей",
  period: "Период",
  periods: "Периоды",
  zone: "Зона",
  zones: "Зоны",
  group: "Группа",
  groups: "Группы",
  level: "Уровень",
  addNewPC: "Добавлять новые ПК по умолчанию",
  userStatuses: "Статусы пользователей",
  userStatus: "Статус пользователя",
  "user statuss": "Статусы пользователей",
  saved: "Сохранено",
  updated: "Обновлено",
  removed: "Удалено",
  clientSources: "Источники клиентов",
  clientSource: "Источник клиента",
  "client sources": "Источники клиентов",
  paymentTerms: "Условия оплаты",
  paymentTerm: "Условие оплаты абонемента",
  "payment terms": "Условия оплаты абонемента",
  deviceReserveStatuses: "Статусы резерва устройств",
  deviceReserveStatus: "Статус резерва устройства",
  "device reserve statuses": "Статусы резерва устройств",
  "device reserve statuss": "Статусы резерва устройств",
  device: "Устройство",
  devices: "Устройства",
  mac: "MAC",
  ip: "IP",
  type: "Тип",
  invalid_mac_address_format: "Невалидный формат mac адреса",
  invalid_ip_address_format: "Невалидный формат IP адреса",
  buySubscriptions: "Купить абонементы",
  buySubscription: "Купить абонемент",
  "buy subscriptions": "Купить абонементы",
  tariff: "Тариф",
  tariffs: "Тарифы",
  costPerHour: "Стоимость за час",
  applyDiscountLoyaltyProgramme:
    "Применять скидку пользователя по программе лояльности?",
  oneTimeMinimumPaymentAtStartOfTheSession:
    "Единоразовый минимальный платеж на старте сессии",
  minimumSessionTime: "Минимальное время сессии",
  costPerMinimumSessionTime: "Минимальный платеж",
  clubUser: "Пользователь",
  clubUsers: "Пользователи",
  "club users": "Пользователи",
  sessionHistory: "История сеансов",
  balanceHistory: "История баланса",
  checkHistory: "История чеков",
  rolesAndAccessInCAP: "Роли и доступ в CAP",
  "tariff settings": "Установка тарифов",
  tariffSettings: "Установка тарифов",
  tariffSetting: "Установка тарифa",
  addPeriod: "Добавить период",
  setTariff: "Установить тарифы",
  settings: "Настройки",
  "service categorys": "Категории услуг",
  serviceCategories: "Категории услуг",
  serviceCategory: "Категория услуги",
  "launch methods": "Способы запуска",
  "launch method": "Способ запуска",
  launchMethods: "Способы запуска",
  launchMethod: "Способ запуска",
  "content sections": "Разделы контента",
  contentSections: "Разделы контента",
  contentSection: "Раздел контента",
  showInShell: "Отображать в shell",
  content: "Контент",
  newContent: "Новый контент",
  "filter-period": {
    yesterday: "Вчера",
    last7Days: "Последние 7 дней",
    lastWeek: "Прошлая неделя",
    last30Days: "Последние 30 дней",
    currentMonth: "Текущий месяц",
    lastMonth: "Прошлый месяц",
    currentYear: "Текущий год",
    lastYear: "Прошлый год",
    all: "Весь период",
    select: "Выбрать период",
  },
  availableIn: "Доступен в",
  gamesUpdates: "Обновления игр",
  allOffices: "Все офисы",
  allStatuses: "Все статусы",
  allContent: "Весь контент",
  addContent: "Добавить контент",
  allCategories: "Все категории",
  searchInContent: "Поиск в контенте",
  showContentToUpdate: "Показать контент для обновления",
  selectAction: "Выберите действие",
  archive: "Архив",
  startupErrors: "Ошибки запуска",
  pcNumber: "ПК #",
  date: "Дата",
  club: "Клуб",
  status: "Статус",
  open: "Открыт",
  closed: "Закрыт",
  intoTheArchives: "В архив",
  makeActive: "Сделать активным",
  makeInactive: "Сделать неактивным",
  appointClubs: "Назначить клубы",
  restore: "Восстановить",
  shop: "Магазин",
  cash: "Касса",
  generalSettings: "Основные настройки",
  sessionSettings: "Настройки сессии",
  taxation: "Налогообложение",
  cashRegisterOperations: "Касса и кассовые операции",
  subscriptions: "Абонементы",
  loyaltyProgram: "Программа лояльности",
  shellInterface: "Интерфейс Shell",
  userRegistration: "Регистрация пользователей",
  clubAccounts: "Клубные аккаунты (ключи)",
  trafficRestrictions: "Ограничения трафика",
  sessionEndReminder: "Напоминание об окончании сессии",
  timezone: "Часовой пояс",
  language: "Язык",
  currency: "Валюта перевода",
  billingStart: "Старт биллинга",
  sessionRestart: "Перезагрузка после окончания сессии",
  restartTime: "Время до перезагрузки ПК (сек.)",
  showPlayerName: "Отображение имени игрока на карте клуба",
  resetAccountBalance: "Обнуление баланса аккаунтов",
  resetAccountBalanceDays: "Обнулить через (дн.)",
  resetUnusedChecks: "Обнуление неиспользованных чеков",
  resetUnusedChecksDays: "Обнулить через (дн.)",
  roundingAmount: "Округление сумм (кол-во знаков)",
  defaultRate: "Тариф по умолчанию за час",
  roundingPostpay: "Округление стоимости постоплаты (кол-во знаков)",
  minPaymentForStaff: "Списание минимального платежа для сотрудников",
  taxSystem: "Система налогообложения",
  taxType: "Тип налога",
  maxCheckAmount: "Максимальная сумма чека",
  checkRefund: "Возврат чеков",
  checkCancellation: "Отмена чеков",
  showChange: "Расчёт сдачи",
  roundingRefundAmount: "Округление суммы возврата (кол-во знаков)",
  allowGuestPurchase: "Покупка для незарегистрированных",
  allowMultipleSubscriptions: "Покупка более одного абонемента",
  offerSubscriptionOnStart: "Выбор абонемента на старте",
  showLoyaltyProgram: "Отображение программы лояльности",
  promoCodeVisibility: "Отображение промокодов",
  replenishmentBonuses: "Бонусы за пополнение",
  employeeBonuses: "Бонусы для сотрудников",
  applyDiscountToSubscriptions: "Применять скидку к абонементам",
  countSubscriptionsForLevel: "Учитывать абонементы для уровня",
  billingPriority: "Приоритет для биллинга",
  steamLaunchPath: "Адрес для запуска Steam",
  showUnavailableContent: "Отображать не доступный контент",
  backgroundImage: "Фоновое изображение",
  backgroundImageHint:
    "Мин.разрешение - 1920x1080px. Рекомендуем использовать изображения в темных тонах.",
  logo: "Логотип",
  image: "Изображение",
  logoSizeHint: "Размер логотипа - 176x88 px.",
  showMyDocumentsFolder: "Показывать папку 'Мои документы'",
  phoneNumber: "Номер телефона",
  phoneNumberHint: "Укажите телефонный код страны (префикс)",
  birthDate: "Дата рождения",
  address: "Адрес",
  addresses: "Адреса",
  document: "Документ",
  mandatorySourceField: "Поле 'Откуда о нас узнали' обязательное",
  selectSources: "Выберите источники",
  postpaidClients: "Клиенты с постоплатой",
  unregisteredClients: "Незарегистрированные клиенты (Гости)",
  speedLimit: "Ограничение скорости",
  speedLimitHint: "Если необходимо ограничить трафик",
  sessionEndReminderMinutes: "Напоминание об окончании сессии (мин)",
  sessionEndReminderHint:
    "За сколько минут до конца сессии/абонемента предупреждать",
  timeOutMinutes: "Time-out (мин)",
  timeOutHint: "Промежуток времени в минутах между звуковыми уведомлениями",
  volumeLevelPercentage: "Уровень громкости (%)",
  volumeLevelHint: "Настройка уровня громкости уведомления",
  soundTrack: "Звуковая дорожка",
  default: "По умолчанию",
  custom: "Индивидуальная",
  promoCodeActive: "Промокоды активны",
  promoCodeInactive: "Промокоды неактивны",
  replenishmentBonusPercentage: "% от суммы пополнения",
  replenishmentBonusFixed: "Фиксированная сумма",
  billingPriorityMain: "Основной баланс",
  billingPriorityBonus: "Бонусный баланс",
  selectFile: "Выберите файл",
  selectBackgroundImage: "Выберите фоновое изображение",
  selectLogoImage: "Выберите лого",
  logoImage: "Лого",
  serchUserName: "Поиск пользователя",
  searchFirstName: "Поиск имени",
  searchName: "Поиск по наименованию",
  searchLastName: "Поиск фамилии",
  searchEmail: "Поиск почты",
  actions: "Действие",
  "Are you sure you want to delete this user?":
    "Вы уверены, что хотите удалить этого пользователя?",
  update: "Обновить",
  createUser: "Создать пользователя",
  editUser: "Редактирование пользователя",
  "Failed to fetch gender data": "Не удалось получить данные",
  "Gender created successfully": "Пол успешно создан",
  "Gender updated successfully": "Пол успешно обновлен",
  "Please input gender!": "Пожалуйста, укажите пол!",
  "Confirm Deletion": "Подтвердите удаление",
  "Are you sure you want to delete this gender?":
    "Вы уверены, что хотите удалить этот пол?",
  createGender: "Создание пола",
  editGender: "Редактирование пола",
  "Are you sure you want to delete this client source?":
    "Вы уверены, что хотите удалить этот источник клиента?",
  "Failed to fetch client source data":
    "Не удалось получить исходные данные клиента",
  "Client source created successfully": "Источник клиента успешно создан",
  "Client source updated successfully": "Источник клиента успешно обновлен",
  createClientSource: "Создание источника клиента",
  editClientSource: "Редактирование источника клиента",
  "Please input client source!": "Пожалуйста, введите источник клиента!",
  createUserType: "Создание типа пользователя",
  editUserType: "Редактирование типа пользователя",
  "Please input user type!": "Пожалуйста, введите тип пользователя",
  "User type created successfully": "Тип пользователя успешно создано",
  "User type updated successfully": "Тип пользователя успешно обновлен",
  "Are you sure you want to delete this user type?":
    "Вы уверены, что хотите удалить этот тип пользователя?",
  clients: "Клиенты",
  shortName: "Краткое наименование",
  fullName: "Полное наименование",
  FullName: 'ФИО',
  clientType: "Тип клиента",
  signer: "Подписант",
  basisOf: "Действует на основании",
  powerOfAttorneyNumber: "Договорённость №",
  integrationCode: "Код клиента",
  additionalInfo: "Дополнительная информация",
  country: "Страна",
  ogrn: "ОГРН",
  region: "Область",
  city: "Город",
  createCompany: "Создание компании",
  editCompany: "Редактирование компании",
  selectPermission: "Выберите права",
  accountNumber: "Номер счёта",
  corrBank: "Банк корреспондент",
  Bank: "Банк",
  addressType: "Тип адреса",
  flat: "Квартира",
  block: "Корпус",
  street: "Улица",
  index: "Индекс",
  house: "Дом",
  contactType: "Тип связи",
  value: "Значение",
  requisites: "Реквизиты",
  account: "Счёт",
  accounts: "Счета",
  createAccount: "Создать счёт",
  createAddress: "Создать адрес",
  addContact: "Добавить средство связи",
  dateFormation: "Дата формирования",
  statusContract: "Статус контракта",
  dateSign: "Дата подписания",
  addAccount: "Добавить счёт",
  addAddress: "Добавить адрес",
  contract: "Договора",
  responsible: "Ответственный",
  contractTerm: "Срок действия договора",
  penaltiesSize: "Размер неустойки",
  principle: "Принципал",
  agent: "Агент",
  chats: "Чаты",
  createContract: "Создание договора",
  editContract: "Изменение договора",
  chatNumber: "Чат #",
  send: "Отправить",
  enterMessage: "Введите ваше сообщение",
  contractNumber: "№ договора",
  assignments: "Поручения",
  createAssignment: "Создать поручение",
  exporterName: "Наименование экпортера",
  importContract: "Импортный контракт",
  currencyPaymentAmount: "Сумма валютного платежа",
  bankAddress: "Bank Name",
  swiftCode: "SWIFT CODE",
  destination: "Purpose of payment",
  rateToRouble: "Курс к рублю РФ",
  client: "Клиент",
  "user type": "Тип пользователя",
  "user status": "Статус пользователя",
  "client source": "Источник клиента",
  assignment: "Поручения",
  chat: "Чат",
  createWorkplace: "Создание рабочего места",
  editWorkplace: "Редактирование рабочего места",
  application: "Заявки",
  "application status": "Статус заявки",
  createApplication: "Создание заявки",
  editApplication: "Редактирование заявки",
  applications: "Заявки",
  createCity: 'Создание города',
  editCity: 'Редактирование города',
  sysSetting: "Системные настройки",
  'SysSetting created successfully': 'Системные настройки созданы',
  'SysSetting updated successfully': 'Системные настройки изменены',
  code: 'Код',
  createSysSetting: 'Создать системную настройку',
  editSysSetting: 'Редактировать системную настройку',
  editAssignment: "Рудактировать поручение",
  templates: 'Шаблоны',
  file: "Документ",
  files: "Документы",
  requisite: 'Реквизит',
  'Please select date': 'Пожалуйста, выберите дату',
  "Please select client": 'Пожалуйста, выберите клиента',
  "Please select account number!": "Выберите номер счёта!",
  fileUploadedSuccessfully: 'Файл загружен успешно',
  fileUploadError: 'Ошибка загрузки файла',
  fileRemovedSuccessfully: 'Файл удален успешно',
  'Please enter proxy': 'Пожалуйста, введите доверенности',
  'Please enter name': 'Пожалуйста, введите название',
  'Please enter inn': 'Пожалуйста, введите ИНН',
  'Please enter kpp': 'Пожалуйста, введите КПП',
  'Please enter okpo': 'Пожалуйста, введите ОКПО',
  'Please enter ceo': 'Пожалуйста, введите генерального директора',
  'Please enter email': 'Пожалуйста, введите электронную почту',
  'Please select basis': 'Пожалуйста, выберите основание',
  'Please enter address': 'Пожалуйста, введите адрес',
  'Please enter bank': 'Пожалуйста, введите банк',
  'Please enter corrAccount': 'Пожалуйста, введите корреспондентский счёт',
  'Please enter currentAccount': 'Пожалуйста, введите текущий счёт',
  'Please enter bik': 'Пожалуйста, введите БИК',
  'Please enter token': 'Пожалуйста, введите токен',
  "officeBasedOn": {
    "Charter": "Устав",
    "Proxy": "Доверенность"
  },
  'Please enter the bank name': 'Пожалуйста, введите название банка',
  'Enter bank name': 'Введите название банка',
  'Please enter the correspondent account': 'Пожалуйста, введите корреспондентский счёт',
  'Enter correspondent account': 'Введите корреспондентский счёт',
  'Please enter the current account': 'Пожалуйста, введите расчётный счёт',
  'Enter current account': 'Введите расчётный счёт',
  'Please enter the BIK': 'Пожалуйста, введите БИК',
  'Enter BIK': 'Введите БИК',
  validationErrorTitle: 'Ошибка валидации',
  validationErrorMessage: 'Пожалуйста, заполните все обязательные поля',
  'Office account created successfully': 'Счет компании успешно создана',
  'Office deleted successfully': 'Компания успешно удалена',
  'Please fill in all required fields': 'Пожалуйста, заполните все обязательные поля',
  'Office updated successfully': 'Компания успешно обновлена',
  'Office created successfully': 'Компания успешно создана',
  "clientTypes": {
    "Individual": "Физическое лицо",
    "LegalEntity": "Юридическое лицо"
  },
  "clientBasisOf": {
    "Charter": "Устав",
    "PowerOfAttorney": "Доверенность",
    "Certificate": "Свидетельство",
  },
  "clientAddressType": {
    "Physical": "Физический",
    "Legal": "Юридический"
  },
  contact: "Средства связи",
  clientContactType: {
    "Phone": "Телефон",
    "Email": "Электронная почта",
    "Telegram": "Телеграм"
  },
  noData: "Нет данных",
  noMessages: "Нет сообщений",
  'Please input signer': 'Пожалуйста, введите подписанта',
  'Please input post': 'Пожалуйста, введите должность',
  'Please input powerOfAttorneyNumber': 'Пожалуйста, введите номер доверенности',
  'Please input integrationCode': 'Пожалуйста, введите код',
  'Please input additionalInfo': 'Пожалуйста, введите дополнительную информацию',
  'Please select at least one country': 'Пожалуйста, выберите хотя бы одну страну',
  'Please input ogrn': 'Пожалуйста, введите ОГРН',
  'Please select at least one region': 'Пожалуйста, выберите хотя бы один регион',
  'Please select at least one city': 'Пожалуйста, выберите хотя бы один город',
  'Please input kpp': 'Пожалуйста, введите КПП',
  'Please input inn': 'Пожалуйста, введите ИНН',
  'Please input okpo': 'Пожалуйста, введите ОКПО',
  'Please input currency': 'Пожалуйста, введите валюту',
  'Please input currency code': 'Пожалуйста, введите код валюты',
  currencyName: "Название валюты",
  createCurrency: "Создать валюту",
  editCurrency: "Редактировать валюту",
  'Created successfully': 'Создано успешно',
  'Updated successfully': 'Обновлено успешно',
  'Removed successfully': 'Удалено успешно',
  'Are you sure you want to delete?': 'Вы уверены, что хотите удалить эту запись?',
  'Yes': 'Да',
  'Cancel': 'Отмена',
  'Select a role': 'Выберите роль',
  'Select a module': 'Выберите модуль',
  'Name': 'Название',
  'Module added successfully': 'Модуль добавлен успешно',
  'Role added successfully': 'Роль добавлена успешно',
  currencies: "Валюты",
  cities: "Города",
  countries: "Страны",
  regions: "Регионы",
  createCountry: "Создать страну",
  editCountry: "Редактировать страну",
  'Please input country': 'Пожалуйста, введите страну',
  'Please input country code': 'Пожалуйста, введите код страны',
  'Country created successfully': 'Страна создана успешно',
  createRegion: "Создать регион",
  editRegion: "Редактировать регион",
  'Please input region': 'Пожалуйста, введите регион',
  'Please input city': 'Пожалуйста, введите город',
  createUserStatus: "Создать статус пользователя",
  editUserStatus: "Редактировать статус пользователя",
  'Please input user status': 'Пожалуйста, введите статус пользователя',
  'new application': 'Новая заявка',
  'contract negotiation': 'Согласование договора',
  'contract signing': 'Подписание документа',
  'invoice negotiation': 'Согласование инвойса',
  'assignment negotiation': 'Согласование поручения',
  'awaiting payments': 'Ожидание платежей',
  'assignment execution': 'Исполнение поручения',
  'awaiting confirmation': 'Ожидание подтверждения',
  'act signing': 'Подписание актов',
  'toWork': 'Взять в работу',
  'sayHello': 'Отправить приветствие',
  'send requisits': 'Отправить реквизиты',
  'form an agreement': 'Сформировать договор',
  'contract template': 'Шаблон документа',
  'signing': 'На подписание',
  'signed': 'Договор подписан',
  'approve': 'Согласовать',
  'send invoice requirements': 'Отправить требования по инвойсу',
  'to assignment negotiation': 'Инвойс согласован',
  'approve SWIFT': 'Согласование SWIFT на отправку',
  'send instructions': 'Отправить поручения',
  'instructions approved': 'Поручение подписано',
  'agree on course': 'Курс согласован',
  'payments received': 'Платежи получены',
  'execute the order': 'Исполнено',
  'signing of acts': 'Подписание актов',
  'the acts were signed': 'Акты подписаны',
  'sended successfully': 'Успешно отправлены',
  'application number': '№ заявки',
  'stage': 'Стадия',
  'application date': 'Дата заявки',
  'responsibleBy': 'Ответственный менеджер',
  'operativeBy': 'Операционист',
  'application parameters': 'Параметры заявки',
  'Name of goods/services in the contract/invoice': 'Наименование товаров/услуг в контракте/ инвойсе',
  'recipients bank details': 'Данные банка получателя',
  'import contact': 'Contract details, invoice',
  'conditions for making a payment': 'Условия для проведения платежа',
  'letter of credit': 'Аккредетив',
  'due date': 'Срок исполнения',
  'transfer amount': 'Сумма перевода',
  'the commission that the client receives': 'Rate',
  'exchange rate': 'Курс валюты',
  'prize': 'Премия',
  'total amount': 'Итого сумма',
  'credit body': 'Тело',
  'bank interest': 'Интерес банка',
  'total': 'Общая сумма',
  'profit': 'Прибыль',
  'Office': 'Офис',
  'client details': 'Реквизиты клиента',
  'company name': 'Наименование компании',
  'signing method': 'Метод подписания',
  'signing date': 'Дата подписания',
  'contract number': 'Номер договора',
  'contract templates': 'Шаблон документа',
  "contractStatus": {
    "New": "Новый",
    "Signing": "Подписание",
    "Active": "Активный",
    "Inactive": "Неактивный"
  },
  paymentAmount: "Сумма платежа",
  destinationOffice: "Назначение платежа",
  currencyOffice: "Валюта платежа",
  officeAccount: "Рекзивиты агента",
  remunerationAmount: "Сумма вознаграждения",
  remunerationCurrency: "Валюта вознаграждения",
  letterOfCredit: "Аккредитив",
  'Please enter contract ID': 'Пожалуйста, введите № договора',
  'Please enter client ID': 'Пожалуйста, выберите клиента',
  'Please enter office ID': 'Пожалуйста, выберите компанию',
  'Please select formation date': 'Пожалуйста, выберите дату формирования',
  'Please select signature date': 'Пожалуйста, выберите дату подписания',
  'Please enter exporter name': 'Пожалуйста, введите имя экспортера',
  'Please enter import contract': 'Пожалуйста, введите договор импорта',
  'Please enter payment amount': 'Пожалуйста, введите сумму платежа',
  'Please select currency ID': 'Пожалуйста, выберите валюту',
  'Please enter bank name': 'Пожалуйста, введите название банка',
  'Please enter bank address': 'Пожалуйста, введите адрес банка',
  'Please enter account number': 'Пожалуйста, введите номер счета',
  'Please enter SWIFT code': 'Пожалуйста, введите код SWIFT',
  'Please enter destination': 'Пожалуйста, введите назначение',
  'Please enter payment terms': 'Пожалуйста, введите условия оплаты',
  'Please enter rate to rouble': 'Пожалуйста, введите курс в рублях',
  'Please enter payment amount for office': 'Пожалуйста, введите сумму платежа',
  'Please enter destination office': 'Пожалуйста, введите назначение платежа',
  'Please select office currency': 'Пожалуйста, выберите валюту платежа',
  'Please select office account': 'Пожалуйста, выберите реквизиты платежа',
  'Please enter remuneration amount': 'Пожалуйста, введите сумму вознаграждения',
  'Please select remuneration currency': 'Пожалуйста, выберите валюту вознаграждения',
  'Please select office': 'Пожалуйста, выберите компанию',
  'Please input penalty': 'Пожалуйста, введите размер неустойки',
  'Please input your login': 'Пожалуйста, введите ваш логин',
  'Please input your username': 'Пожалуйста, введите имя пользователя',
  'Please input your password': 'Пожалуйста, введите пароль',
  'Please input your firstName': 'Пожалуйста, введите ваше имя',
  'Please input your lastName': 'Пожалуйста, введите вашу фамилию',
  'Please select an office': 'Пожалуйста, выберите компанию',
  'Please select at least one role': 'Пожалуйста, выберите роль',
  'Please select a gender': 'Пожалуйста, выберите пол',
  'Please select a user type': 'Пожалуйста, выберите тип пользователя',
  'Please input your email': 'Пожалуйста, введите ваш email',
  "userStatusPage": {
    "Pending": "Ожидает",
    "Active": "Активен",
    "Suspended": "Приостановлен",
    "Locked": "Заблокирован"
  },
  'Validation Error': 'Ошибка валидации',
  'Please correct the highlighted fields and try again.': 'Пожалуйста заполните необходимые поля и попробуйте снова',
  'SwiftSum': 'Swift',
  'diadoc': 'ЭЦП Диадок',
  'manual': 'Факсимиле',
  'back': 'Вернуться',
  'validation_errors': {
    'please_enter_name': 'Пожалуйста введите имя',
    'please_enter_kpp': 'Пожалуйста введите кпп',
    'please_enter_inn': 'Пожалуйста введите ИНН',
    'please_enter_application_number': 'Пожалуйста введите № заявки',
    'please_enter_application_date': 'Пожалуйста введите дату заявки',
    'please_enter_stage': 'Пожалуйста введите статус',
    'please_enter_responsibleBy': 'Пожалуйста введите ответственного',
    'please_enter_client': 'Пожалуйста выберите клиента',
    'please_enter_operativeBy': 'Пожалуйста введите операциониста',
    'please_enter_products': 'Пожалуйста введите название товаров/услуг',
    'please_enter_recipientBankAccountNumber': 'Пожалуйста введите номер текущего счета',
    'please_enter_recipientBankSwiftCode': 'Пожалуйста введите SWIFT-код',
    'please_enter_recipientBankAddress': 'Пожалуйста введите адрес банка',
    'please_enter_recipientBankBankName': 'Пожалуйста введите название банка',
    'please_enter_recipientBankPaymentPurpose': 'Пожалуйста введите назначение платежа',
    'please_enter_recipientBankImportContract': 'Пожалуйста введите импортный контракт',
    'please_enter_paymentTermsLetterOfCredit': 'Пожалуйста выберите аккредитив',
    'please_enter_paymentTermsExecutionPeriod': 'Пожалуйста введите срок исполнения',
    'please_enter_paymentTermsTransferAmount': 'Пожалуйста введите сумму перевода',
    'please_enter_paymentTermsRate': 'Пожалуйста введите комиссию клиента',
    'please_enter_paymentTermsTransferCurrency': 'Пожалуйста выберите валюту перевода',
    'please_enter_paymentTermsExchangeRate': 'Пожалуйста введите курс валюты',
    'please_enter_paymentTermsSwift': 'Пожалуйста введите сумму SWIFT',
    'please_enter_paymentTermsBonus': 'Пожалуйста введите премию',
    'please_enter_paymentTermsTotalAmount': 'Пожалуйста введите итоговую сумму',
    'please_enter_paymentTermsPrincipal': 'Пожалуйста введите тело',
    'please_enter_paymentTermsBankInterest': 'Пожалуйста введите банковский процент',
    'please_enter_paymentTermsTotalSum': 'Пожалуйста введите итоговую сумму',
    'please_enter_paymentTermsProfit': 'Пожалуйста введите прибыль',
    'please_enter_paymentTermsOffice': 'Пожалуйста введите офис',
    'please_enter_clientDetailsCompanyName': 'Пожалуйста введите название компании',
    'please_enter_clientDetailsFullName': 'Пожалуйста введите полное имя',
    'please_enter_clientDetailsBankName': 'Пожалуйста введите банк',
    'please_enter_clientDetailsPosition': 'Пожалуйста введите должность',
    'please_enter_clientDetailsAccountNumber': 'Пожалуйста введите номер счета',
    'please_enter_clientDetailsKpp': 'Пожалуйста введите КПП',
    'please_enter_clientDetailsCorrespondentAccount': 'Пожалуйста введите корреспондентский счет',
    'please_enter_clientDetailsAddress': 'Пожалуйста введите адрес',
    'please_enter_clientDetailsBik': 'Пожалуйста введите БИК',
    'please_enter_clientDetailsEmail': 'Пожалуйста введите email',
    'please_enter_clientDetailsSignatureMethod': 'Пожалуйста введите метод подписи',
    'please_enter_clientDetailsSignatureDate': 'Пожалуйста введите дату подписания',
    'please_enter_clientDetailsPowerOfAttorney': 'Пожалуйста введите доверенность',
    'please_enter_clientDetailsContractDurationYears': 'Пожалуйста введите срок контракта',
    'please_enter_clientDetailsContractNumber': 'Пожалуйста введите номер договора',
    'please_enter_clientDetailsPenaltySize': 'Пожалуйста введите размер штрафов',
    'please_select_bank': 'Пожалуйста выберите банк',
    'please_account_currency': 'Пожалуйста введите валюту счета',
    'please_enter_companyName': 'Пожалуйста введите Company Name',
    'please_enter_companyAddress': 'Пожалуйста введите Адрес компании',
    'please_enter_actNumber': 'Пожалуйста введите № Акта',
    'please_enter_dateExecutionSwift': 'Пожалуйста введите Дата перечисления Swift',
    'please_enter_dateActSigning': 'Пожалуйста введите Дату подписания акта',
    'please_enter_actualExchangeRate': 'Пожалуйста введите Фактический курс обмена',
    'please_enter_dateCashReceipt': 'Пожалуйста введите Дату поступления денежных средств',
    'please_enter_amountAfterConversion': 'Пожалуйста введите Сумму после конвертации',
    'please_enter_application_source': 'Пожалуйста выберите Источник заявки',
    'please_input_dateAssignmentSigning': 'Пожалуйста введите Дату подписания поручения',
    'please_input_assignmentNumber': 'Пожалуйста введите № поручения',
    'please_enter_removeFromReport': 'Пожалуйста введите  Убрать из отчёта',
    'please_enter_paymentStatus': 'Пожалуйста введите Статус платежа',
    'please_enter_comments': 'Пожалуйста введите Комментарии',
  },
  fullAddress: 'Адрес',
  isGroup: 'Группа',
  documents: 'Документы',
  createdAt: 'Дата создания',
  updatedAt: 'Последнее обновление',
  calculation: 'Отправить расчеты',
  'Select status': 'Фильтровать по статусу',
  'Select responsibleBy': 'Фильтровать по ответственному',
  'Funds have been credited to the account': 'Денежные средства поступили на счет',
  'please enter a description': 'Пожалуйста введите описание',
  'enter description': 'Введите описание',
  'assignment signing': 'Подписание поручения',
  accountCurrency: 'Валюта счета',
  chatId: 'Номер чата',
  actNumber: '№ Акта',
  dateExecutionSwift: 'Дата перечисления Swift',
  dateActSigning: 'Дата подписания акта',
  actualExchangeRate: 'Фактический курс',
  dateCashReceipt: 'Дата поступления денежных средств',
  amountAfterConversion: 'Сумма после конвертации',
  generateExcel: 'Сгенерировать Excel',
  'Client created successfully': 'Клиент создан успешно',
  'Client updated successfully': 'Клиент обновлен успешно',
  'Client deleted successfully': 'Клиент удален успешно',
  'Account created successfully': 'Счет создан успешно',
  'Account updated successfully': 'Счет обновлен успешно',
  'Account deleted successfully': 'Счет удален успешно',
  'Address created successfully': 'Адрес создан успешно',
  'Address updated successfully': 'Адрес обновлен успешно',
  'Address deleted successfully': 'Адрес удален успешно',
  'Contact created successfully': 'Средства связи создан успешно',
  'Contact updated successfully': 'Средства связи обновлен успешно',
  'Contact deleted successfully': 'Средства связи удален успешно',
  'Please input your basisOf': 'Пожалуйста выберите основание',
  'Please input your clientType': 'Пожалуйста выберите тип клиента',
  'Please input client name': 'Пожалуста введите имя клиента',
  'Please input client fullName': 'Пожалуйста введите полное имя',
  'Please input corrAccount': 'Пожалуйста введите корреспондентский счет',
  'Please select at least one currency': 'Пожалуйста выберите валюту',
  'Please input bank name': 'Пожалуйста введите имя банка',
  'Please input contact value': 'Пожалуйста введите значение',
  'Please input a valid email': 'Пожалуйста введите корректный email',
  'application source': 'Источник заявки',
  'document templates': 'Шаблон документа',
  'create client': 'Создание клиента',
  'edit client': 'Редактирование клиента',
  'create app': 'Создать заявку',
  'dateAssignmentSigning': 'Дата подписания поручения',
  'assignmentNumber': '№ поручения',
  Pending: 'На исполнении',
  Executed: 'Исполнено',
  Returned: 'Возврат',
  FullRefund: 'Полный возврат',
  removeFromReport: 'Убрать из отчёта',
  comments: 'Комментарии',
  paymentStatus: 'Статус платежа',
  endDate: 'Дата по',
  startDate: 'Дата с',
  recipientBankAddress: 'Адрес Банка',
  companyAddress: 'Адрес Компании',
  clientDetailsAccountNumber: 'Расчетный счет',
  'searchApplicationNumber': 'Поиск по номеру заявки',
  'searchTransferAmount': 'Поиск по сумме перевода',
  'searchClient': 'Поиск по клиенту',
  'searchChat': 'Поиск по чату',
  'searchResponsibleBy': 'Поиск по операционисту',
  application_name_must_be_unique_exception: 'Номер заявки должен быть уникальный',
  'has_linked_entities': 'Есть связанные записи',
  editApplicationStatus: 'Редактировать статус заявки',
  position: 'Позиция',
  isFinish: 'Завершена',
  applicationStatuses: 'Статусы заявок',
};
